import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface DocumentParseData {
  _id: string;
  document_store_id: string;
  uploaded_file_id: string;
  file_name: string;
  parse_status: string;
  parse_result?: any;
  error_message?: string;
  createdAt: string;
  updatedAt: string;
  [key: string]: any;
}

export interface DocumentParseDataListParams {
  skip: number;
  limit: number;
  document_store_id: string;
}

export interface DocumentParseDataListResponse {
  success: boolean;
  code: number;
  data: {
    documentparseDataList: DocumentParseData[];
    total_count: number;
  };
}

export interface GetParseStatusByIdsParams {
  document_parse_ids: string[];
  document_store_id: string;
}

export interface ParseStatusUpdate {
  _id: string;
  document_parse_status: string;
  document_parse_duration: number;
  document_parse_start_time: string;
  document_parse_end_time: string;
}

export interface GetParseStatusByIdsResponse {
  success: boolean;
  code: number;
  data: ParseStatusUpdate[];
}

class DocumentParseDataService {
  // POST: Get list of parsed files
  async getDocumentParseDataList(
    params: DocumentParseDataListParams
  ): Promise<DocumentParseDataListResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.DOCUMENT_PARSE_DATA.LIST,
        params
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching document parse data:', error);
      throw error;
    }
  }

  // POST: Get status by parse IDs for polling
  async getStatusByIds(
    params: GetParseStatusByIdsParams
  ): Promise<GetParseStatusByIdsResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.DOCUMENT_PARSE_DATA.GET_STATUS_BY_IDS,
        params
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching parse statuses:', error);
      throw error;
    }
  }
}

export const documentParseDataService = new DocumentParseDataService();
export default documentParseDataService;
